import { useContext } from 'react';
import { assert } from 'ts-essentials';

import { FeatureFlagsContext, type FeatureFlagsCtx } from '../context';

export const useFeatureFlagsSetter = (): Pick<
  FeatureFlagsCtx,
  'setCompanyFeatureFlags' | 'setUserFeatureFlags'
> => {
  const context = useContext(FeatureFlagsContext);
  assert(
    context.companyFeatureFlags,
    'useFeatureFlagsSetter must be used inside of a FeatureFlagsContext',
  );

  return context;
};
